import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular-router-loader/src!./ClientApp/imports.ts